import EtablissementConventionNom from '@/generated/controls/etablissement/EtablissementConventionNom.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: EtablissementConventionNom
})
